export default function useLangCodeTranslated(code) {
	const data = {
		es: "Español",
		en: "English",
		fr: "Français",
		de: "Deutsch",
		ja: "日本語",
	};

	return data[code] || code;
}
